.row {
  display: grid;
  grid-template-columns: 44px 1fr 130px 70px 110px 90px;
  gap: 14px;
  align-items: center;
  padding: 12px 14px;
  background: var(--white);
  border: 1.5px solid var(--line-soft);
  border-radius: var(--r-md);
  cursor: pointer;
  text-align: left;
  font-family: var(--sans);
  transition: border-color 0.1s, background 0.1s;
  width: 100%;
}

.row:hover {
  border-color: var(--ink-soft);
  background: var(--off);
}

.row.selected {
  border-color: var(--ink);
  border-width: 2px;
  background: var(--off);
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: var(--r-sm);
  background: var(--orange);
  color: var(--ink);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.nameCell {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  font-weight: 800;
  font-size: 14px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.id {
  font-family: var(--mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: var(--mute);
  margin-top: 2px;
}

.planCell {
  font-size: 13px;
  color: var(--ink-soft);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.adh {
  font-weight: 800;
  font-size: 14px;
  text-align: right;
}

.adhGood { color: var(--green); }
.adhOk { color: var(--orange-deep); }
.adhBad { color: var(--red); }

.weight {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 700;
  font-size: 13px;
  color: var(--ink-soft);
}

.deltaUp { color: var(--red); font-size: 11px; font-weight: 700; }
.deltaDown { color: var(--green); font-size: 11px; font-weight: 700; }

.statusBadge {
  text-align: center;
  padding: 5px 10px;
  border-radius: 999px;
  border: 2px solid var(--line);
  font-weight: 800;
  font-size: 10px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.statusActive { background: var(--green-soft); color: var(--ink); }
.statusAttention { background: var(--orange); color: var(--ink); }
.statusRisk { background: var(--red); color: var(--white); }
